import { THREE_CARD_BLOCK_DESCRIPTION_LIMIT } from "entities/modules/constants";
import { ModuleContentBlocksContent } from "entities/modules/types";
import { useGeneralData } from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer/stores/useGeneralData";
import React, { ChangeEvent, type FC } from "react";
import TextField from "shared/components/Form/TextField";
import UploadImageField from "shared/components/Form/UploadImageField";
import { COLOR_BLACK } from "shared/theme/colors";
import { StyledContainer } from "./styled";

type Props = {
  item: ModuleContentBlocksContent;
  index: number;
  isLoadingFile: boolean;
};

const CardBlockForm: FC<Props> = ({ item, index, isLoadingFile }) => {
  const {
    contentBlocks,
    threeCardBlockImages,
    setThreeCardBlockImages,
    setContentBlocks,
  } = useGeneralData();

  if (!contentBlocks) {
    return null;
  }

  const onChangeTitle = (e: ChangeEvent<HTMLInputElement>) => {
    const newContent = contentBlocks.map((item, i) =>
      index === i ? { ...item, title: e.target.value } : item,
    );

    setContentBlocks(newContent);
  };

  const onChangeDescription = (e: ChangeEvent<HTMLInputElement>) => {
    const newContent = contentBlocks.map((item, i) =>
      index === i ? { ...item, description: e.target.value } : item,
    );

    setContentBlocks(newContent);
  };

  const onChangeImage = (file: File | null) => {
    const newImages = threeCardBlockImages.map((item, i) =>
      index === i ? file : item,
    );

    setThreeCardBlockImages(newImages);
  };

  return (
    <StyledContainer>
      <TextField
        id={`title-${index}`}
        label="Title*"
        placeholder="Click here to edit text"
        fullWidth
        required
        value={item.title}
        onChange={onChangeTitle}
        labelColor={COLOR_BLACK}
      />
      <TextField
        id={`description-${index}`}
        label="Description*"
        placeholder="Click here to edit text"
        fullWidth
        required
        multiline
        value={item.description}
        onChange={onChangeDescription}
        charactersLimit={THREE_CARD_BLOCK_DESCRIPTION_LIMIT}
        InputProps={{ minRows: 5 }}
        labelColor={COLOR_BLACK}
      />
      <UploadImageField
        imageFile={threeCardBlockImages[index]}
        setImageFile={onChangeImage}
        label={"Background icon*"}
        isLoading={isLoadingFile}
      />
    </StyledContainer>
  );
};

export default CardBlockForm;
